// Tiny pub/sub so any component (e.g. Portfolio cards) can prefill the Contact form.
const listeners = new Set();

export function onPrefill(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function emitPrefill(patch) {
  listeners.forEach((fn) => {
    try { fn(patch); } catch { /* noop */ }
  });
}
